<template>
  <div class="handlingCase">
    <el-row :gutter="10" type="flex" class="row-bg"  justify="center">
      <el-col :span="24">
        <div class="aa">
          <mt-datetime-picker
            ref="picker"
            type="date"
            year-format="{value} 年"
            month-format="{value} 月"
            date-format="{value} 日"
            @confirm="handleConfirm"
            v-model="dateval">
          </mt-datetime-picker>
          <mt-datetime-picker
            ref="picker1"
            type="date"
            year-format="{value} 年"
            month-format="{value} 月"
            date-format="{value} 日"
            @confirm="handleConfirms"
            v-model="dateval">
          </mt-datetime-picker>
        </div>
        <el-row style="margin-bottom:0;background:#fff;padding:0 10px 0 14px;" :gutter="16">
          <el-col :lg='5' :md='8' :sm='24' :xs='24'>
            <div class="block">
              <div class="title">
                车型
              </div>
              <div>
                <el-input v-model="formData.vehicleType" placeholder="请填写车型"></el-input>
              </div>
            </div>
          </el-col>
           <el-col :lg='5' :md='8' :sm='24' :xs='24'>
            <div class="block">
              <div class="title">
                车型代码
              </div>
              <div>
                <el-input v-model="formData.vehicleCode" placeholder="请填写车型"></el-input>
              </div>
            </div>
          </el-col>
          <el-col :lg='5' :md='8' :sm='24' :xs='24'>
            <div class="block">
              <div class="title">
                vin
              </div>
              <div>
                <el-input v-model="formData.vin" placeholder="请填写vin"></el-input>
              </div>
            </div>
          </el-col>
          <el-col :lg='5' :md='8' :sm='24' :xs='24'>
            <div class="block">
              <div class="title">
                案件名称
              </div>
              <div>
                <el-input v-model="formData.title" placeholder="请填写案件名称"></el-input>
              </div>
            </div>
          </el-col>
          <el-col :lg='5' :md='8' :sm='24' :xs='24' v-if="user.type == 1">
            <div class="block">
              <div class="title">
                部位
              </div>
              <div>
                <el-select v-model="formData.parts" placeholder="请选择">
                  <el-option
                    v-for="item in partIdsArr"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-col>
          <el-col :lg='5' :md='8' :sm='24' :xs='24' v-if="user.type == 1">
            <div class="block">
              <div class="title">
                现象分类
              </div>
              <div>
                <el-select v-model="formData.phenomenons" placeholder="请选择">
                  <el-option
                    v-for="item in phenomenonIdsArr"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-col>
          <el-col :lg='5' :md='8' :sm='24' :xs='24' v-if="user.type == 1">
            <div class="block">
              <div class="title">
                三包
              </div>
              <div>
                <el-select v-model="formData.warrantyPeriod" placeholder="请选择">
                  <el-option v-for="(item, index) in warrantyPeriodOption" :key="index"  :label="item" :value="item">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-col>
          <el-col :lg='5' :md='8' :sm='24' :xs='24' v-if="user.type == 1">
            <div class="block">
              <div class="title">
                维修类型
              </div>
              <div>
                <el-select v-model="formData.kubun" placeholder="请选择">
                  <el-option
                    v-for="item in kubunOption"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-col>
          <el-col :lg='5' :md='8' :sm='24' :xs='24' v-if="user.type == 1">
            <div class="block">
              <div class="title">
                发动机型号
              </div>
              <div>
                <el-input v-model="formData.engineModel" placeholder="请填写发动机型号"></el-input>
              </div>
            </div>
          </el-col>
          <el-col :lg='5' :md='8' :sm='24' :xs='24' v-if="user.type == 1">
            <div class="block">
              <div class="title">
                DLR名称
              </div>
              <div>
                <el-input v-model="formData.dealerName" placeholder="请填写DLR名称"></el-input>
              </div>
            </div>
          </el-col>
          <el-col :lg='5' :md='8' :sm='24' :xs='24' v-if="user.type == 1 && (user.level=='LEADER'||user.level=='SECTION'||user.level=='ALL')">
            <div class="block">
              <div class="title">
                NTL姓名
              </div>
              <div>
                <el-select v-model="formData.relayusername" placeholder="请选择">
                  <el-option v-for="item in leaderArr" :key="item[0]" :label="item[1]" :value="item[0]">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-col>
          <el-col :lg='9' :md='24' :sm='24' :xs='24'>
            <div class="block">
              <div class="title">
                提交时间区间
              </div>
              <div>
                <el-date-picker placeholder="开始日期" type="date" :clearable="true" value-format="yyyy-MM-dd" v-model="formData.startDate"></el-date-picker>
              </div>
              <div>
                <el-date-picker placeholder="结束日期" type="date" :clearable="true" value-format="yyyy-MM-dd" v-model="formData.endDate"></el-date-picker>
              </div>
            </div>
          </el-col>
          <el-col :lg='5' :md='8' :sm='24' :xs='24' v-if="user.type == 1">
            <div class="block">
              <div class="title">
                对应方向
              </div>
              <div>
                <el-select v-model="formData.directions" placeholder="请选择">
                  <el-option v-for="item in directionOption" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-col>
          <el-col :lg='5' :md='8' :sm='24' :xs='24' v-if="user.type == 1&&user.level=='ALL'">
            <div class="block">
              <div class="title">
                区域
              </div>
              <div>
                <el-select v-model="formData.fieldId" clearable placeholder="请选择">
                  <el-option v-for="item in areaOption" :key="item.field" :label="item.fueldname" :value="item.field">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="searchCase">

          <!-- <input type="text" placeholder="请输入关键词" v-model="formData.key"> -->
          <span @click="searchBtn">检索</span>
        </div>
        <div class="warning" style="margin-top:8px" v-if="user.type == 1">
          <div
            @click="formData.gt2h = !formData.gt2h;warningClick()"
            :class="formData.gt2h? 'warningSelection' : ''"
          >
            <b></b>超2H未答
          </div>
          <div
            @click="formData.gt6h = !formData.gt6h;warningClick()"
            :class="formData.gt6h? 'warningSelection' : ''"
          >
            <b></b>超6H
          </div>
          <div
            @click="formData.gt8h = !formData.gt8h;warningClick()"
            :class="formData.gt8h? 'warningSelection' : ''"
          >
            <b></b>超8H
          </div>

          <!-- <div
            @click="formData.gt24h = !formData.gt24h;warningClick()"
            :class="formData.gt24h? 'warningSelection' : ''"
          >
            <b></b>超24H
          </div> -->
        </div>
        <div class="warning" style="padding-top:0" v-if="user.type == 1">
          <div
            @click="formData.easy = !formData.easy;warningClick()"
            :class="formData.easy? 'warningSelection' : ''"
          >
            <b></b>易
          </div>
          <div
            @click="formData.hard = !formData.hard;warningClick()"
            :class="formData.hard? 'warningSelection' : ''"
          >
            <b></b>难
          </div>
          <div
            @click="formData.lt2h = !formData.lt2h;warningClick()"
            :class="formData.lt2h ? 'warningSelection' : ''"
          >
            <b></b>非预警
          </div>

          <div
            @click="formData.all = !formData.all;warningClick()"
            :class="formData.all? 'warningSelection' : ''"
          >
            <b></b>全部
          </div>
        </div>
        <div class="warning" style="padding-top:0" v-if="user.type == 1">
          <div
            @click="warningClick('S')"
            :class="cases[0]=='S'||cases[1]=='S'? 'warningSelection' : ''"
          >
            <b></b>S
          </div>
          <div
            @click="warningClick('A')"
            :class="cases[0]=='A'||cases[1]=='A'? 'warningSelection' : ''"
          >
            <b></b>A
          </div>
        </div>
        <div class="newsCaseList" v-for="item in newsCaseListData" :key="item.id">
          <ul>
            <li>
              <span>案件名称：</span>
              <span v-if="item.color == 'none'">{{item.title}}</span>
              <span v-if="item.color == 'yellow'" class="caseFcyellow">{{item.title}}</span>
              <span v-if="item.color == 'orange'" class="caseFcorange">{{item.title}}</span>
              <span v-if="item.color == 'red'" class="caseFcred">{{item.title}}</span>
            </li>
            <li>
              <span>DLR名称：</span>
              <span>{{item.dealerName}}</span>
            </li>
            <li>
              <span>案件编号：</span>
              <span v-if="item.color == 'none'">{{item.caseNo}}</span>
              <span v-if="item.color == 'yellow'" class="caseFcyellow">{{item.caseNo}}</span>
              <span v-if="item.color == 'orange'" class="caseFcorange">{{item.caseNo}}</span>
              <span v-if="item.color == 'red'" class="caseFcred">{{item.caseNo}}</span>
            </li>
            <li>
              <span>VIN&nbsp;编码：</span>
              <span>{{item.vin}}</span>
            </li>
            <li>
              <span>车&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;型：</span>
              <span>{{item.vehicleType}}</span>
            </li>
            <li>
              <span>发布时间：</span>
              <span class="clOrange">{{item.startDatetime}}</span>
            </li>
            <li>
              <span>初次对应时间：</span>
              <span>{{item.firstDate}}</span>
            </li>
            <li>
              <span>最终方案对应提出时间：</span>
              <span>{{item.finalSolutionDate}}</span>
            </li>
            <li>
              <span>结案时间：</span>
              <span>{{item.doneDate}}</span>
            </li>
            <li>
              <span>案件经过时间：</span>
              <span>{{item.elapsed}}</span>
            </li>
            <li>
              <span>状态：</span>
              <span>{{item.statusDisplay}}</span>
            </li>
            <div style="margin-top:10px;">
              <el-button @click="jump(item.id)" style="background:#00ae66;color:#fff;margin-right:10px;" size="small">查看详情</el-button>
              <el-badge :value="item.unreadCount?item.unreadCount:''">
                <el-button size="small" style="background:#00ae66;color:#fff;" @click="chat(item.id)">消息</el-button>
              </el-badge>
            </div>
          </ul>
        </div>
        <infinite-loading :on-infinite="onInfinite" ref="infiniteLoading">
          <span slot="no-more">没有更多消息了</span>
          <div slot="no-results">暂无数据:(</div>
        </infinite-loading>
      </el-col>
    </el-row>

  </div>
</template>
<script>
import HandlingCaseData, { getHandlingCaseData } from '@/api/case.js'
import InfiniteLoading from 'vue-infinite-loading'
import { Indicator, DatetimePicker } from 'mint-ui'
import {
  getDefaultTableData,
  getOptions,
  getTableData,
  getArealist1,
  getArealist,
  getLeader
} from '@/api/export.js'
export default {
  components: {
    InfiniteLoading
  },
  data () {
    return {
      newsCaseListData: [], // List数据
      searchKey: '', // 搜索关键词KEY
      partIdsArr: [],
      phenomenonIdsArr: [],
      warrantyPeriod: [],
      warrantyPeriodOption: [],
      kubunOption: [],
      directionOption: [],
      leaderArr: [],
      areaOption: [],
      formData: {
        gt24h: false,
        gt8h: false,
        gt6h: false,
        gt2h: false,
        lt2h: false,
        all: false,
        easy: false,
        hard: false,
        key: '',
        pageSize: 10,
        pageNumber: 0,
        startDate: '',
        endDate: '',
        casePriority: '',
        fieldId: ''
      },
      totalPages: 1, // 总页数
      user: {},
      cases: [],
      now: '',
      pageSize: 10,
      pageNumber: 0,
      dateval: ''
    }
  },
  created () {
    this.user = JSON.parse(localStorage.getItem('user'))
    console.log(this.user)
    getOptions(0).then(res => {
      this.directionOption = res.data.directionOption
      this.kubunOption = res.data.kubunOption
      this.partIdsArr = res.data.partOption
      this.phenomenonIdsArr = res.data.phenomenonOption
      this.warrantyPeriodOption = res.data.warrantyPeriodOption
    })
    getLeader().then(res => {
      this.leaderArr = res.data.data
    })
    getArealist().then(res => {
      this.areaOption = res.data.data
    })
  },
  methods: {
    getNow (d) {
      const year = d.getFullYear()
      const month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
      const date = d.getDate() < 10 ? '0' + (d.getDate()) : d.getDate()
      const hours = d.getHours()
      const minutes = d.getMinutes()
      const second = d.getSeconds()
      let resStr = year + '-' + month + '-' + date
      return resStr
    },
    handleConfirm () {
      console.log(this.getNow(this.dateval))
      this.$set(this.formData, 'startDate', this.getNow(this.dateval))
    },
    handleConfirms () {
      console.log(this.getNow(this.dateval))
      this.$set(this.formData, 'endDate', this.getNow(this.dateval))
    },
    openPicker1 () {
      if (this.formData.endDate) {
        this.dateval = this.formData.endDate
      } else {
        this.dateval = new Date()
      }
      this.$refs.picker1.open()
    },
    openPicker () {
      if (this.formData.startDate) {
        this.dateval = this.formData.startDate
      } else {
        this.dateval = new Date()
      }
      this.$refs.picker.open()
    },
    // searchBtn() {
    //   if (this.searchKey != "") {
    //     Indicator.open({
    //       text: '加载中...',
    //       spinnerType: 'fading-circle'
    //     });
    //     searchHandlingCaseData(data).then((res) => {
    //       this.newsCaseListData = res.data.content
    //       Indicator.close();
    //     })
    //   } else {
    //     alert("请输入要搜索的内容");
    //   }

    // },
    jump (e) {
      var status = 2
      this.$router.push({ path: '/casedetail/' + status + '/' + e })
    },
    warningClick (e) {
      // 预警选择事件
      console.log(this.cases.length)
      if (e && e.length > 0) {
        if (this.cases.length == 0 || this.cases.join(',').indexOf(e) < 0) {
          this.cases.push(e)
        } else if (this.cases.join(',').indexOf(e) >= 0) {
          this.cases.splice(this.cases.indexOf(e), 1)
        }
        this.formData.casePriority = this.cases.join(',')
      }
      this.formData.pageNumber = 0
      this.pageNumber = 0
      let _this = this
      console.log(1)
      this.pageSize = 20
      this.newsCaseListData = []
      this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded')
      setTimeout(function () {
        _this.postData()
      }, 0)
    },
    searchBtn () {
      var key = this.formData.key
      this.formData.pageNumber = 0
      // if (key.length < 1) {
      //   alert("请输入要搜索的内容");
      //   return false;
      // }
      // Indicator.open({
      //   text: "加载中...",
      //   spinnerType: "fading-circle"
      // });
      this.pageNumber = 0
      this.pageSize = 20
      this.newsCaseListData = []
      this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded')
      this.onInfinite()
    },
    chat (e) {
      var status = 1
      this.$router.push({ path: '/newsChat/' + status + '/' + e })
    },
    postData () {
      // 数据数据列表
      // getHandlingCaseData(0, 10, this.formData).then(res => {
      //   Indicator.close();
      //   if(res.data){
      //     this.newsCaseListData = [];
      //     this.totalPages = res.data.totalPages;
      //     for (var i = 0; i < res.data.content.length; i++) {
      //       this.newsCaseListData.push(res.data.content[i]);
      //     }
      //     this.newsCaseListData.splice(this.newsCaseListData.length);
      //   }

      // });
      getHandlingCaseData(this.pageNumber, this.pageSize, this.formData).then((res) => {
        this.totalPages = res.data.totalPages
        if (res.data.content.length) {
          this.pageNumber += 1
          this.newsCaseListData.push(...res.data.content)
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded')
        } else {
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
        }
        if (res.data.content.length < this.pageSize) {
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
        }
      })
    },
    onInfinite ($state) {
      // this.formData.pageNumber += 1;
      // Indicator.open({
      //   //加载提示
      //   text: "加载中...",
      //   spinnerType: "fading-circle"
      // });
      // getHandlingCaseData(0, 10, this.formData).then(res => {
      //   Indicator.close();
      //   this.totalPages = res.data.totalPages;
      //   for (var i = 0; i < res.data.content.length; i++) {
      //     this.newsCaseListData.push(res.data.content[i]);
      //   }
      //   this.newsCaseListData.splice(this.newsCaseListData.length);
      //   this.$refs.infiniteLoading.$emit("$InfiniteLoading:loaded");
      //   var totalPages = this.totalPages;
      //   if (this.totalPages === this.totalPages) {
      //     this.$refs.infiniteLoading.$emit("$InfiniteLoading:complete");
      //   }
      // });
      getHandlingCaseData(this.pageNumber, this.pageSize, this.formData).then((res) => {
        this.totalPages = res.data.totalPages
        if (res.data.content.length) {
          this.pageNumber += 1
          this.newsCaseListData.push(...res.data.content)
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded')
        } else {
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
        }
        if (res.data.content.length < this.pageSize) {
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
        }
      })
    }
  }
}

</script>

<style scoped>
body,
html {
  margin: 0;
  padding: 0;
  background-color: #f4f4f4;
  height:100%;
}
.block {
		line-height: 40px;
		display: flex;
		/* justify-content: space-around; */
	}
.block .title {
		min-width: 85px;
		/* text-align: center; */
	}
ul {
  list-style: none;
  margin: 0px;
  padding: 0px;
}
ul {
  margin: 0;
}
ul li {
  list-style-type: none;
}
input {
  padding: 0;
}
.handlingCase{ 	overflow-x: hidden;
		margin-left: 10px;
		margin-right: 10px;
    height:100%;
    }
.warning {
  width: calc(100% - 10px);
  background-color: #fff;
  overflow: hidden;
  padding: 7px 10px 7px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baselin;
  flex-shrink: 10;
}
.warning div {
  flex-grow: 4;
  padding: 7px 0;
  border: 1px solid #e3e3e3;
  color: #666;
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
  margin-left: 10px;
}

.warning div b {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 1px solid #e3e3e3;
  position: relative;
  left: -1px;
  top: 2px;
  border-radius: 3px;
}
.warningSelection {
  color: #4da2fd !important;
  border-color: #4da2fd !important;
  background-color: #ebf5ff !important;
}
.warningSelection b {
  background-image: url(../assets/images/warningSelection.png);
  border: 0 !important;
  background-size: 15px;
  background-position: center center;
}
.searchCase {
  text-align: center;
  height: 40px;
  overflow: hidden;
  background-color: #fff;
  padding: 10px 10px 3px 14px;
  position: relative;
}
.searchCase input {
  width: calc(100% - 93px);
  height: 34px;
  border: 1px solid #e3e3e3;
  text-indent: 1em;
  border-radius: 3px 0 0 3px;
}
.searchCase span {
  display: block;
  width: 88px;
  float: right;
  font-size: 14px;
  color: #fff;
  height: 36px;
  line-height: 36px;
  background-color: #00ae66;
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  top: 10px;
  border-radius: 0 3px 3px 0;
}
.searchCase span:hover {
  cursor: pointer;
}
.newsCaseList {
  background-color: #fff;
  text-align: left;
  margin-top: 10px;
  padding: 10px 15px;
}
.newsCaseList ul li {
  overflow: hidden;
  margin-top: 5px;
}
.newsCaseList ul li:hover {
  cursor: pointer;
}
.clOrange {
  color: #ff8f00 !important;
}
.newsCaseList ul li span {
  display: block;
  float: left;
  font-size: 14px;
  color: #333;
  height: 22px;
  line-height: 22px;
}
.caseFcyellow {
  color: #f7b904 !important;
}
.caseFcorange {
  color: orange !important;
}
.caseFcred {
  color: red !important;
}
.infinite-status-prompt {
  margin-bottom: 15px;
  color: #999;
  font-size: 12px;
}
</style>
